import { createSvgIcon } from '@automata/mui-theme';
export const ReleaseCapsIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 17V34H62V17H34ZM33 14C31.8954 14 31 14.8954 31 16V35C31 36.1046 31.8954 37 33 37H63C64.1046 37 65 36.1046 65 35V16C65 14.8954 64.1046 14 63 14H33Z"
    />
    <path d="M38 17H40V35H38V17Z" />
    <path d="M44 17H46V35H44V17Z" />
    <path d="M50 16.5H52V34.5H50V16.5Z" />
    <path d="M56 16H58V34H56V16Z" />
    <path d="M50.1151 68.6619L35.973 54.5197L33.8516 56.6411L47.9938 70.7832L50.1151 68.6619Z" />
    <path d="M48.0062 70.783L62.1484 56.6408L60.027 54.5195L45.8849 68.6617L48.0062 70.783Z" />
    <path d="M46.5001 67H49.5001V41H46.5001V67Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 74.7832V79.7832H77V74.7832H80V82.7832H16V74.7832H19Z"
    />
  </svg>,
  'ReleaseCapsIcon'
);
